import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';
import { ServerErrorGuard } from 'src/core/guards/server-error.guard';
import { ServiceUnavailableComponent } from './service-unavailable.component';

export const serviceUnavailableRoutes: Routes = [
  {
    path: '',
    component: ServiceUnavailableComponent,
    canActivate: [ServerErrorGuard],
  },
];


